export enum CashChargeCode {
  Unknown = 0,
  Start, // 캐시충전 프로세스 시작
  Success, // 캐시충전 성공
}
